import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { addWeekProgramFlyerDate, deleteAllWeekProgramFlyerDate, printDataUpdateRequest, setWeekProgramFlyerCurrentWeek, setWeekProgramFlyerCustomPeriodActive, updateWeekProgramFlyerOrder } from '../../../actions'
import PrintFlyerWeeks from '../present/PrintFlyerWeeks'
import { FEATURES, PRINT_WEEKS, WEEK_PROGRAM_FLYER_DATA } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'

const mapStateToProps = state => ({
    weeks: getData(state, PRINT_WEEKS),
    features: getData(state, FEATURES),
    weekProgramFlyerData: getData(state, WEEK_PROGRAM_FLYER_DATA),
    hasChanges: getData(state, [WEEK_PROGRAM_FLYER_DATA, 'hasChanges']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    printToolSetWeek: (week) => {
          dispatch(setWeekProgramFlyerCurrentWeek(week))
          dispatch(setWeekProgramFlyerCustomPeriodActive(false))
          dispatch(printDataUpdateRequest())
    },
    printToolSetCustomPeriodActive: (active) => {
        dispatch(setWeekProgramFlyerCustomPeriodActive(active))
    },
    printToolAddDatePeriod: (dateObj) => {
        dispatch(addWeekProgramFlyerDate(dateObj))
    },
    printUpdateRequest: () => {
        dispatch(printDataUpdateRequest())
    },
    reorderItems: (dragIndex, hoverIndex) => {
        const order = ownProps.weekProgramFlyerData.dateSettings.order
        const movedElement = order.splice(dragIndex, 1)[0];
        order.splice(hoverIndex, 0, movedElement);

        dispatch(updateWeekProgramFlyerOrder(order, 'dateSettings'))
    },
    deleteAllDateItems: () => {
        dispatch(deleteAllWeekProgramFlyerDate())
    }
})

const PrintWeekProgramFlyerWeeksContainer = ({
    printType, 
    deleteAllDateItems, 
    weekProgramFlyerData, 
    reorderItems, 
    hasChanges, 
    printToolSetCustomPeriodActive, 
    printUpdateRequest, 
    printToolAddDatePeriod, 
    cinemaId,
    printID, 
    landscape, 
    week, 
    features, 
    weeks, 
    closePagePath,
    printToolSetWeek
}) => {
    return <PrintFlyerWeeks
            features={features}
            customDatePeriod={true}
            weekProgramFlyerData={weekProgramFlyerData}
            deleteAllDateItems={deleteAllDateItems}
            printType={printType}
            hasChanges={hasChanges}
            cinemaId={cinemaId}
            printID={printID}
            landscape={landscape}
            printToolSetCustomPeriodActive={printToolSetCustomPeriodActive}
            printUpdateRequest={printUpdateRequest}
            printToolAddDatePeriod={printToolAddDatePeriod}
            weeks={weeks}
            activeWeek={week}
            printToolSetWeek={printToolSetWeek}
            closePagePath={closePagePath}
            reorderItems={reorderItems}
        />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintWeekProgramFlyerWeeksContainer)